export default __webpack_public_path__ + "static/media/ght-logo.770040ba.png";